import { ASResponse } from "types/searchApi/response";
import { INIT_DATA_CACHE_KEY, INIT_DATA_CACHE_TTL } from "./constants";

export interface InitDataCache {
  value: ASResponse;
  expiresAt: number;
}

const isValidRes = (data?: Partial<ASResponse>): data is ASResponse =>
  Boolean(data?.response?.product_list?.length) &&
  Boolean(data?.response?.autosuggest?.suggestions?.length);

export const getCachedRecommendations = () => {
  try {
    const cachedRex = sessionStorage.getItem(INIT_DATA_CACHE_KEY);
    if (!cachedRex) return null;

    const initData: Partial<InitDataCache> = JSON.parse(cachedRex);

    if (
      !isValidRes(initData.value) ||
      !initData.expiresAt ||
      Date.now() > initData.expiresAt
    ) {
      sessionStorage.removeItem(INIT_DATA_CACHE_KEY);
      return null;
    }

    return initData.value;
  } catch (error) {
    console.error(error);
    sessionStorage.removeItem(INIT_DATA_CACHE_KEY);
    return null;
  }
};

export const setCachedRecommendations = (value: ASResponse) => {
  try {
    if (!isValidRes(value)) throw new TypeError("Invalid value");

    const cacheValue: InitDataCache = {
      expiresAt: Date.now() + INIT_DATA_CACHE_TTL,
      value,
    };
    sessionStorage.setItem(INIT_DATA_CACHE_KEY, JSON.stringify(cacheValue));
  } catch (error) {
    console.error(error);
  }
};
